import {
  InputHTMLAttributes,
  useRef,
  useState,
  useEffect,
  ChangeEvent,
} from 'react';
import { Label } from '../../atom/Label';
import {
  Input,
  InputContainer,
  RowWrapper,
  Wrapper,
  Left,
} from './MemoInput.style';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  value?: string;
}

export const MemoInputView = ({
  disabled,
  label,
  value,
  onChange,
  ...otherProps
}: Props) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value || '');

  // keep local state in sync with parent value
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  // adjust width on inputValue change
  useEffect(() => {
    if (inputRef.current !== null) {
      inputRef.current.style.width = inputValue.length * 8 + 6 + 'px';
    }
  }, [inputValue]);

  const handleContainerClick = () => {
    if (inputRef.current !== null) {
      inputRef.current.focus();
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    onChange?.(event); // bubble up to parent
  };

  return (
    <Wrapper>
      <RowWrapper>
        <Label>{label}</Label>
      </RowWrapper>

      <InputContainer
        disabled={disabled}
        focused={focused}
        onClick={handleContainerClick}
      >
        <Left>
          <Input
            value={inputValue}
            disabled={disabled}
            focused={focused}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            ref={inputRef}
            onChange={handleChange}
            {...otherProps}
          />
        </Left>
      </InputContainer>
    </Wrapper>
  );
};
